export const MILAN_LOCATION: any = {
  lat: 45.47741454797728,
  lng: 9.199590998404119,
};

export const PIN_ICON_SVG =
  "M25.679,2.25A18.8,18.8,0,0,0,6.75,20.8c0,13.912,18.929,34.45,18.929,34.45S44.607,34.713,44.607,20.8A18.8,18.8,0,0,0,25.679,2.25Zm0,25.175a6.626,6.626,0,1,1,0-13.25,6.626,6.626,0,1,1,0,13.25Z";

export const PIN_ICON_STROKE_COLOR = "#282828";
export const PIN_ICON_STROKE_COLOR_SELECTED = "#545960";
export const PIN_ICON_FILL_COLOR = "#545960";
export const PIN_ICON_FILL_COLOR_SELECTED = "#8DC53F";

export const PIN_ICON_ZOOMED_STROKE_COLOR = "#FFFFFF";
export const PIN_ICON_ZOOMED_FILL_COLOR = "#8DC53F";

export const POLYGON_STROKE_COLOR = "#8DC53F";
export const POLYGON_FILL_COLOR = "#8DC53F66";

export const AREA_STROKE_COLOR_SELECTED = "#BE5CCB6B";
export const AREA_FILL_COLOR_SELECTED = "#BE5CCB";

export const AREA_STROKE_COLOR_SELECTED_DETAILS = "#FFFFFF";
export const AREA_FILL_COLOR_SELECTED_DETAILS = "#BE5CCB";

export const AREA_STROKE_COLOR = "#545960";
export const AREA_FILL_COLOR = "#5459606A";
